function positionText() {
    $(".slider-variable-item").each(function () {
        var contentHeight = $(this).find('.slider-variable-item-content').height();
        $(this).find('.slider-variable-item-spacer').outerHeight(contentHeight);
    });
}

$(document).ready(function () {
    positionText();
});

$( window ).on( "resize", function() {
    positionText();
});
